import { ServiceOrderState } from '@mews-commander/data-access';

export const isRequestedState = (state: ServiceOrderState): state is ServiceOrderState.Requested =>
    state === ServiceOrderState.Requested;
export const isInquiredState = (state: ServiceOrderState): state is ServiceOrderState.Inquired =>
    state === ServiceOrderState.Inquired;
export const isOptionalState = (state: ServiceOrderState): state is ServiceOrderState.Optional =>
    state === ServiceOrderState.Optional;
export const isConfirmedState = (state: ServiceOrderState): state is ServiceOrderState.Confirmed =>
    state === ServiceOrderState.Confirmed;
export const isStartedState = (state: ServiceOrderState): state is ServiceOrderState.Started =>
    state === ServiceOrderState.Started;
export const isProcessedState = (state: ServiceOrderState): state is ServiceOrderState.Processed =>
    state === ServiceOrderState.Processed;
export const isCanceledState = (state: ServiceOrderState): state is ServiceOrderState.Canceled =>
    state === ServiceOrderState.Canceled;
export const isUnconfirmedState = (state: ServiceOrderState) =>
    isInquiredState(state) || isOptionalState(state) || isRequestedState(state);
export const isDefiniteState = (state: ServiceOrderState) =>
    isConfirmedState(state) || isStartedState(state) || isProcessedState(state);
export const isActiveState = (state: ServiceOrderState) => isUnconfirmedState(state) || isDefiniteState(state);
export const isHoldingState = (state: ServiceOrderState) => isDefiniteState(state) || isOptionalState(state);
export const isDefiniteOrCanceledState = (state: ServiceOrderState) => isDefiniteState(state) || isCanceledState(state);
export const isBeforeCheckInState = (state: ServiceOrderState) => isUnconfirmedState(state) || isConfirmedState(state);
